/**
 * @generated SignedSource<<79f7aa897160067d1dcba8c20c921e3f>>
 * @relayHash f28d7a6163339a7803906a97b10c79d5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/463.0.0-2024-05-21T07:50:23.801Z/IFramedPromoPartnershipAddToWhitelistMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromotionBuyerWhitelistRuleCustomerSelfAddInput = {
  clientMutationId?: string | null;
  promoToken: string;
  userId: string;
};
export type IFramedPromoPartnershipAddToWhitelistMutation$variables = {
  input: PromotionBuyerWhitelistRuleCustomerSelfAddInput;
};
export type IFramedPromoPartnershipAddToWhitelistMutation$data = {
  readonly promotionBuyerWhitelistRuleUserSelfAdd: {
    readonly code: string | null;
  } | null;
};
export type IFramedPromoPartnershipAddToWhitelistMutation = {
  response: IFramedPromoPartnershipAddToWhitelistMutation$data;
  variables: IFramedPromoPartnershipAddToWhitelistMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PromotionBuyerWhitelistRuleCustomerSelfAddPayload",
    "kind": "LinkedField",
    "name": "promotionBuyerWhitelistRuleUserSelfAdd",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IFramedPromoPartnershipAddToWhitelistMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IFramedPromoPartnershipAddToWhitelistMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-misc/463.0.0-2024-05-21T07:50:23.801Z/IFramedPromoPartnershipAddToWhitelistMutation",
    "metadata": {},
    "name": "IFramedPromoPartnershipAddToWhitelistMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "62f4a2581aa711417135d57bf888e34f";

export default node;
